// lib/data.ts

// --- 2. PARTNERS & CERTIFICATIONS (Bottom Scroller) ---
// Using ACTUAL images from allcode.com assets where available
export const certifications = [
  // --- Strategic Partners (from /partners) ---
  { 
    name: "Fondo", 
    logo: "https://assets.allcode.com/wp-content/uploads/2025/05/image-319.png" 
  },
  { 
    name: "Rho", 
    logo: "https://assets.allcode.com/wp-content/uploads/2025/05/image-321.png" 
  },
  { 
    name: "Burkland", 
    logo: "https://assets.allcode.com/wp-content/uploads/2025/09/Burkland-Associates-logo.png" 
  },
  {   
    name: "Mighty Capital", 
    logo: "https://assets.allcode.com/wp-content/uploads/2025/09/logo-1.svg" 
  },
  { 
    name: "Founders Network", 
    logo: "https://assets.allcode.com/wp-content/uploads/2025/05/FN-Logo-Founders-Network.webp" 
  },
  { 
    name: "Hallstone Ventures", 
    logo: "https://assets.allcode.com/wp-content/uploads/2025/09/hallstoneventures.png" 
  },
  
  // --- Certifications (from Home Page Scroller) ---
  { name: "IBM Partner", logo: "https://logo.clearbit.com/ibm.com" },
  { name: "TD SYNNEX", logo: "https://logo.clearbit.com/tdsynnex.com" },
  { name: "Cloudflare", logo: "https://logo.clearbit.com/cloudflare.com" },
  { name: "Arrow Electronics", logo: "https://logo.clearbit.com/arrow.com" },
  
  // --- Core Cloud Partners (Must Haves) ---
  { name: "AWS Advanced", logo: "https://logo.clearbit.com/aws.amazon.com" },
  { name: "Twilio Build", logo: "https://logo.clearbit.com/twilio.com" }
];

// --- 3. INTERVIEWS (Media) ---
export const interviews = [
  { 
    title: "AI, Cloud, and the Future of Software Teams", 
    source: "Big North Podcast Network",
    date: "Oct 14, 2025",
    url: "https://www.youtube.com/watch?v=dnxYvN9SSQg", 
    type: "Video" 
  },
  { 
    title: "Joel & Charlsie: Internal Interview", 
    source: "Riverside.FM Podcast",
    date: "Aug 28, 2025",
    url: "https://riverside.com/dashboard/studios/roarke-baldwins-studio/projects/68af731498046d345836a753?share-token=2d748a9106aec19ae6a0&content-shared=project&redirect_num=1", 
    type: "Link"
  },
  { 
    title: "AllCode CEO Joel Garcia on Digital Innovation", 
    source: "The Growth Insider by Zunesty",
    date: "Aug 7, 2025",
    url: "https://www.youtube.com/watch?v=9qo2mNKukYo", 
    type: "Video" 
  },
  { 
    title: "Larry interviews Joel Garcia with AllCode.com", 
    source: "SaaS Innovators",
    date: "July 24, 2025",
    url: "https://embed.podcasts.apple.com/us/podcast/episode-07-joel-garcia-with-allcode-com/id1810306683?i=1000718858930",
    type: "Audio" 
  },
  { 
    title: "Pitch, Build, Scale - Startup Founder Stories", 
    source: "Pitch, Build, Scale",
    date: "Oct 14, 2025",
    url: "https://embed.podcasts.apple.com/us/podcast/ai-cloud-and-the-future-of-software-teams-with/id1805879935?i=1000673059524", 
    type: "Audio" 
  }
];

// --- 4. PORTFOLIO (Work Grid) ---
export const portfolio = [
  { 
    client: "LeadIQ", 
    title: "Scaling Data Ingestion", 
    slug: "leadiq-scaling",
    tags: ["AWS", "Serverless", "Node.js"],
    description: "Re-architecting a monolithic ingestion pipeline to serverless, handling 100M+ records daily with zero downtime.",
    image: "/case-studies/leadiq.jpg"
  },
  { 
    client: "BlueMercury", 
    title: "Mobile Commerce Experience", 
    slug: "bluemercury-mobile",
    tags: ["Mobile", "React Native", "iOS"],
    description: "Built the flagship mobile retail experience with real-time inventory sync and loyalty integration.",
    image: "/case-studies/bluemercury.jpg"
  },
  { 
    client: "Globalstar", 
    title: "Satellite Communication Portal", 
    slug: "globalstar-portal",
    tags: ["Web", "Python", "Django"],
    description: "Enterprise customer portal for managing satellite communications hardware and subscriptions.",
    image: "/case-studies/globalstar.jpg"
  },
  { 
    client: "Ten-X", 
    title: "Real Estate Auction Platform", 
    slug: "ten-x-auction",
    tags: ["Web", "React", "High Scale"],
    description: "Modernizing the frontend architecture for the world's largest online real estate auction platform.",
    image: "/case-studies/tenx.jpg"
  },
  { 
    client: "Jitterbit", 
    title: "API Integration Engine", 
    slug: "jitterbit-api",
    tags: ["DevOps", "AWS", "Infrastructure"],
    description: "Automating infrastructure deployment and scaling for a leading API integration platform.",
    image: "/case-studies/jitterbit.jpg"
  },
  { 
    client: "Gametime", 
    title: "Last-Minute Ticketing", 
    slug: "gametime-mobile",
    tags: ["Mobile", "Android", "Consumer"],
    description: "Optimizing the Android application performance for high-traffic game day usage.",
    image: "/case-studies/gametime.jpg"
  }
];